export const FETCH_USER = 'FETCH_USER';
export const SET_USER = 'SET_USER';
export const SET_LOGIN_FAILED = 'SET_LOGIN_FAILED';

